import { getApiUrl } from '../config/api.config.jsx';

class PartnerAdminAPI {
  constructor() {
    this.baseURL = `${getApiUrl()}/partner`;
  }

  authHeaders() {
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token && String(token).trim()) {
      headers.Authorization = `Bearer ${String(token).trim()}`;
    }
    return headers;
  }

  async getAllPartners() {
    try {
      const response = await fetch(`${this.baseURL}/onboarding/all`, {
        headers: this.authHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching all partners:', error);
      throw error;
    }
  }

  async getPartnerDetails(partnerId) {
    try {
      const response = await fetch(`${this.baseURL}/partner/${partnerId}`, {
        headers: this.authHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching partner details:', error);
      throw error;
    }
  }

  async getPartnerFiles(partnerId) {
    try {
      const response = await fetch(`${this.baseURL}/partner/${partnerId}/files`, {
        headers: this.authHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching partner files:', error);
      throw error;
    }
  }

  async updatePartnerStatus(partnerId, status) {
    try {
      const response = await fetch(`${this.baseURL}/partner/${partnerId}/status`, {
        method: 'PUT',
        headers: this.authHeaders(),
        body: JSON.stringify({ status }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating partner status:', error);
      throw error;
    }
  }

  async deletePartner(partnerId) {
    try {
      const response = await fetch(`${this.baseURL}/partner/${partnerId}`, {
        method: 'DELETE',
        headers: this.authHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting partner:', error);
      throw error;
    }
  }

  // Mock data for development
  getMockPartners() {
    return [
      {
        id: '1',
        name: 'Islamic Bank of America',
        email: 'admin@islamicbank.com',
        status: 'active',
        onboardingStatus: 'completed',
        joinDate: '2023-01-15',
        documents: 12,
        phone: '+1-555-0123',
        address: '123 Islamic Way, New York, NY 10001',
        businessType: 'Bank',
        shariaCompliance: 'certified',
      },
      {
        id: '2',
        name: 'Halal Finance Co.',
        email: 'contact@halalfinance.com',
        status: 'pending',
        onboardingStatus: 'in_progress',
        joinDate: '2023-03-20',
        documents: 8,
        phone: '+1-555-0456',
        address: '456 Halal Street, Los Angeles, CA 90210',
        businessType: 'Finance Company',
        shariaCompliance: 'pending',
      },
      {
        id: '3',
        name: 'Sharia Investment Group',
        email: 'info@shariainvest.com',
        status: 'active',
        onboardingStatus: 'completed',
        joinDate: '2023-02-10',
        documents: 15,
        phone: '+1-555-0789',
        address: '789 Investment Ave, Chicago, IL 60601',
        businessType: 'Investment Firm',
        shariaCompliance: 'certified',
      },
      {
        id: '4',
        name: 'Green Finance Solutions',
        email: 'hello@greenfinance.com',
        status: 'inactive',
        onboardingStatus: 'pending',
        joinDate: '2023-04-05',
        documents: 3,
        phone: '+1-555-0321',
        address: '321 Green Lane, Miami, FL 33101',
        businessType: 'Finance Company',
        shariaCompliance: 'pending',
      },
      {
        id: '5',
        name: 'Ethical Banking Corp',
        email: 'support@ethicalbanking.com',
        status: 'active',
        onboardingStatus: 'completed',
        joinDate: '2023-01-30',
        documents: 20,
        phone: '+1-555-0654',
        address: '654 Ethics Blvd, Seattle, WA 98101',
        businessType: 'Bank',
        shariaCompliance: 'certified',
      },
    ];
  }
}

export default PartnerAdminAPI;
